import api from './index'

// 获取活动详情
export const getPrivateActivity = (params) => api.post('/eventActivity/action/getPrivateActivity', params)

// 领券
export const getWXUrlCoupon = (params) => api.post('/coupons/getWXUrlCoupon', params)



export const getCouponActivity = (code) => api.get(`/thirdEventActivity/${code}`)

export const getCouponMessage = (params) => api.post('/thirdEventActivity/getCaptcha', params)

export const getCouponReceive = (params) => api.post('/thirdEventActivity/action/receive', params)
